module.exports = __webpack_public_path__ + "img/hockey-sticks.f22706be.svg";